import { render, staticRenderFns } from "./VVideo.vue?vue&type=template&id=2698c5b5&scoped=true"
import script from "./VVideo.vue?vue&type=script&lang=ts"
export * from "./VVideo.vue?vue&type=script&lang=ts"
import style0 from "./VVideo.vue?vue&type=style&index=0&id=2698c5b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698c5b5",
  null
  
)

export default component.exports